import { writable } from "svelte/store";
const isOpen = writable(false);
const component = writable(null);
const componentProps = writable(null);
export const modalPanelStore = { isOpen, component, componentProps };
